import { Helmet } from 'react-helmet'

export default function StructuredData({ data }) {
    const items = Array.isArray(data) ? data.filter(Boolean) : data ? [data] : []

    if (!items.length) {
        return null
    }

    return (
        <Helmet>
            {items.map((item, index) => (
                <script
                    key={`structured-data-${index}`}
                    type="application/ld+json"
                >
                    {JSON.stringify(item)}
                </script>
            ))}
        </Helmet>
    )
}
